import { Injectable } from '@angular/core';
import { SessionService } from '@monsido/core/session/session.service';
import { ApiService } from '@client/app/services/api/api-service/api.service';
import { BaseRepo, BaseRepoRequestType } from '@client/app/services/api/base-repo/base-repo';
import { ApiUser } from '@client/app/feature-modules/admin/modules/admin-api-tokens/types/api-user.type';
import { MonTableCollection } from '@client/ng2/models/table-collection.interface';
import { contextTokens } from '@monsido/services/request-auxiliary/request-auxiliary.service';

@Injectable({
    providedIn: 'root',
})
export class ApiUsersRepo extends BaseRepo {
    constructor (
        private apiService: ApiService,
        protected sessionService: SessionService,
    ) {
        super();
    }

    getAll (params: BaseRepoRequestType) {
        params = params || {};
        return this.apiService.get<MonTableCollection<ApiUser>>('api_users', params, undefined, contextTokens.REDESIGN_ERROR_ALERT);
    }

    create (params: Omit<ApiUser, 'id' | 'token'>) {
        params = params || {};
        return this.apiService.post<Partial<ApiUser>>('api_users', params, contextTokens.REDESIGN_ERROR_ALERT);
    }

    destroy (apiUser: Pick<ApiUser, 'id'>) {
        return this.apiService.delete<void>('api_users/' + apiUser.id, undefined, contextTokens.REDESIGN_ERROR_ALERT);
    }

    revokeToken (apiUser: Pick<ApiUser, 'id'>) {
        return this.apiService.post<void>('api_users/' + apiUser.id + '/revoke_token', undefined, contextTokens.REDESIGN_ERROR_ALERT);
    }
}
